import {MuWidget} from "mu-widget/lib/MuWidget";

export class IMuWidget extends MuWidget
{

}
/* import { MuWidget } from "./MuWidget";
import { MuBinder, MuBindOpts} from "./MuBinder";
import { ForkItemDialog } from "./InvoiceApproval";

export class IMuWidget // extends MuWidget
{
	public ui : Record<string, AnyElement|any> = {};

	public muAppendContent(html: string) {};

	public muWidgetFromTemplate(templateName : string, container : string|AnyElement|null, params : Record<string, any>|((IMuWidget)=>Record<string, any>) = null, addMethod : "first"|"before"|"after"|"last"|"appendChild" = "appendChild", ref : AnyElement = null) : IMuWidget { return null; };

	public muClear(container : string|AnyElement) {
		if (typeof container === "string") container = this.ui[container];
		(container as AnyElement).innerHTML = "";
	}

	public muRemoveSelf() : void {};

	public container : AnyElement;

	public muGetChildWidgets<T>(container : string|AnyElement) : T[]
	{
		if (typeof container === "string") container = this.ui[container];
		return MuWidget.getChildWidgets(container);
	}

	public muBindList(list: any[], templateName : string, container : string|AnyElement, commonParams : any = null, finalCalback : (widget : any) => void = null) { }

	public muVisible(state : boolean|"toggle", control : string|string[]) { }

	public muSubWidgets : IMuWidget[];

	public muNamedWidget : Record<string, IMuWidget>;

	public muRoot : IMuWidget;
	
	public muParent : IMuWidget|null;

	public muTemplates : Record<string, string>;

	public muTemplateParents : Record<string, AnyElement>;

	public muAddEvent(eventName : string, element : AnyElement, callback : any) : void {}

	public muOnAfterIndex : ((self) => void)[];

	public muBindOpts : Record<string, MuBindOpts[]> = {};

	public muBindData(srcData : any)
	{
		MuBinder.bindData(this.muBindOpts, srcData, this);
		this.muAferBindData();
		this.muAfterBindData(srcData);
	}

	public muFetchData() : any
	{
		return MuBinder.fetchData(this.muBindOpts, this);
	}

	public muDispatchEvent(name: string, ...args) { }

	protected muRegisterEvent(...args) { }

	public addEventListener(name : string, handler : (...args)=>void) { }

	public muEventNames() : string[] { return []; }

	/**
	 * @deprecated Typo error
	 * /
	protected muAferBindData() { }

	protected muAfterBindData(data : any) { }

	public afterIndex() { }

	public static getChildWidgets = function(list, fn = undefined)
	{
		var ls = [];
		for(var i = 0; i < list.children.length; i++)
		{
			var item = list.children[i].widget; // MuWidget.getWidget(list.children[i]);
			if (!item) continue;
			if (fn) item = fn(item);
			ls.push(item);
		};
		return ls;
	}

	// @ts-ignore
	public muActivateWidget(element : AnyElement, opts : MuOpts|null = null, extraParams : Record<string, any>|null = null) : IMuWidget { }

	public muGetMethodCallback(methodName: string) {}

}

export type AnyElement = HTMLElement|SVGElement;

export function SetAttributes(element : AnyElement, attrs : Record<string,any>)
{
	for(const n in attrs)
	{
		element.setAttribute(n, attrs[n].toString());
	}
}

export type MuOpts = Record<string, any>;

*/